import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ApplicationUtilsService } from '@core/services/application-utils/application-utils.service';
import { FeedbackService } from '@core/services/feedback/feedback.service';
import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  @Input() buildVersion: string;
  @Output() releaseNotes = new EventEmitter<void>();

  mailLink: string;
  private routerSubscription: Subscription;

  constructor(
    public configManagerService: ConfigManagerService,
    public feedbackService: FeedbackService,
    public applicationUtilsService: ApplicationUtilsService,
    private router: Router,
    public cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.mailLink = this.feedbackService.getMailLink();

    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.mailLink = this.feedbackService.getMailLink();
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }

  getHelpLink(): string {
    return this.applicationUtilsService.helpLink;
  }

  openHelpLink(): void {
    window.open(this.applicationUtilsService.helpLink);
  }
}
